import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import {
  GetPaidIcon,
  NotesIcon,
  UserJoinIcon,
} from "../../../../components/icons";
import Button from "../../../../components/ui/Button";
import Text from "../../../../components/ui/Text";
import { InfoBlock } from "./parst";

export const HowItWorks = () => {
  return (
    <Box
      sx={{
        padding: { xs: "40px 0", md: "80px 0" },
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Text
        variant="subtitle3"
        component="h2"
        sx={{
          fontSize: { xs: "16px", md: "20px" },
          color: "#203FA9",
        }}
      >
        HOW IT WORKS
      </Text>
      <Text
        component="h3"
        sx={{
          mt: 2,
          fontSize: { xs: "28px", sm: "5.5vw", md: "42px" },
          fontWeight: 900,
          color: "#171717",
        }}
      >
        Get started in minutes
      </Text>
      <Box
        sx={{
          my: { xs: 5, md: 8 },
          display: "grid",
          justifyContent: "center",
          alignItems: "start",
          gridTemplateColumns: { md: "repeat(3, 1fr)" },
          gap: { xs: 2, md: 5, lg: 14 },
        }}
      >
        <InfoBlock
          title="Post your game"
          description="Choose your sport, time and location."
          icon={<NotesIcon />}
        />
        <InfoBlock
          title="Let players join"
          description="Players see your listing and reserve a spot."
          icon={<UserJoinIcon />}
        />
        <InfoBlock
          title="Get paid automatically"
          description="Money is handled. You focus on the game."
          icon={<GetPaidIcon />}
        />
      </Box>
      <Button
        component={Link}
        to="/create-game"
        sx={{
          fontWeight: 500,
          fontSize: { xs: 18, md: 20 },
          height: { xs: 56, md: 48, lg: 56 },
          width: { xs: "100%", sm: "auto" },
          padding: { xs: "0 24px", md: "0 32px" },
        }}
      >
        Launch your game for free
      </Button>
    </Box>
  );
};
